<template>
  <div v-if="vieweds.length" class="section-viewed">
    <section-products-carousel :count="4">
      <h2 slot="title">
        {{ this.$store.state.langs.RECENTLY_VIEWED_HEAD }}
      </h2>
      <p slot="subtitle">
        {{ this.$store.state.langs.WHAT_YOU_SAW_RECENTLY_HEAD_SUBTITLE }}
      </p>
      <layout-product-card
              v-for="(product, index) in vieweds"
              :key="index"
              :product='product'>
      </layout-product-card>
    </section-products-carousel>
  </div>
</template>

<script>
import sectionProductsCarousel from '@/components/sections/section-products-carousel'
import layoutProductCard from '@/components/layout/product/layout-product-card'
export default {
  components: {
      sectionProductsCarousel,
      layoutProductCard
  },
    props: {
        iblock_id: '',
        scrollcontent: {
          type: Boolean,
          default() {
            return false
          }
        }
    },
    data() {
        return {
            vieweds: {}
        }
    },
    created(){
      if( this.scrollcontent ) {
        window.addEventListener('scroll', () => {
          if (pageYOffset > 200 && this.scrollcontent) {
            this.viewedsRequest();
            this.scrollcontent=false;
          }
        });
      }else{
        this.viewedsRequest();
      }
    },
    mounted() {},
    methods: {
        async viewedsRequest() {
            const responseVieweds  = (
                await this.$axios({
                    url: '/ajax/section-viewed.php',
                    method: 'post',
                    params: {
                        clear_cache: this.getGet('clear_cache'),
                        SITE_ID: this.$store.state.langs.SITE_ID,
                        IBLOCK_ID: this.iblock_id,
                    }
                })
            )
            if (responseVieweds) {
                this.vieweds = responseVieweds.data
            } else {
                console.log('responseVieweds')
            }
        },
        getGet(name) {
            var searchString = new URLSearchParams(window.location.search);
            var res = searchString.get(name);
            return res;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
